import { useNavigate } from "react-router";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useAppStatusStore } from "@/shared/stores/appStatusStore";

/**
 * Renders when useApiError receives a FORBIDDEN envelope. A modal (not a toast)
 * because a permission failure usually means the user took an unintended action
 * and dismissing it without acknowledgement risks confusion.
 */
export const ForbiddenModal = () => {
  const message = useAppStatusStore((s) => s.forbiddenMessage);
  const dismiss = useAppStatusStore((s) => s.dismissForbidden);
  const navigate = useNavigate();

  const open = message !== null;

  const handleBack = () => {
    dismiss();
    navigate(-1);
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) dismiss(); }}>
      <DialogContent showCloseButton={false}>
        <DialogHeader>
          <DialogTitle>Permission required</DialogTitle>
          <DialogDescription>
            {message ?? "You don't have permission to do this."}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="default" onClick={handleBack}>
            Back
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
